<template>
  <v-snackbar
    v-model="open"
    :color="snackbarStatus ? 'success' : 'error'"
    top
    right
  >
    {{
      snackbarStatus
        ? "Dane zostały zaktualizowane"
        : "Wystąpił błąd, spróbuj ponownie"
    }}
  </v-snackbar>
</template>

<script>
export default {
  props: {
    snackbar: Boolean,
    snackbarStatus: Boolean
  },
  data() {
    return {
      open: false
    };
  },
  watch: {
    snackbar(newVal) {
      this.open = newVal;
    }
  }
};
</script>
